"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC721__factory = exports.ERC20__factory = exports.ERC1155__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ERC1155__factory_1 = require("./ERC1155__factory");
Object.defineProperty(exports, "ERC1155__factory", { enumerable: true, get: function () { return ERC1155__factory_1.ERC1155__factory; } });
var ERC20__factory_1 = require("./ERC20__factory");
Object.defineProperty(exports, "ERC20__factory", { enumerable: true, get: function () { return ERC20__factory_1.ERC20__factory; } });
var ERC721__factory_1 = require("./ERC721__factory");
Object.defineProperty(exports, "ERC721__factory", { enumerable: true, get: function () { return ERC721__factory_1.ERC721__factory; } });
//# sourceMappingURL=index.js.map